import { Image, Platform } from 'react-native'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { logoUrl, PopulatedValue } from '@ecountabl/lib'
import { extra } from './config'
import api from './api-client'
import { log } from './utility'

export type ValuesStatus = 'idle' | 'loading' | 'success' | 'error'

type ValuesState = {
  map: Record<string, PopulatedValue>
  status: ValuesStatus
  error: string
}

const initialState: ValuesState = {
  map: {},
  status: 'idle',
  error: '',
}

export const fetchValues = createAsyncThunk<any, void, { rejectValue: string }>('values', async (data, _api) => {
  try {
    const map: Record<string, PopulatedValue> = {}
    const values = await api.getPopulatedValues()
    values.forEach(v => {
      const uri = logoUrl(v.bannerImg, extra.cdn)

      if (Platform.OS !== 'web' && uri) {
        // only prefetch images if client-side
        Image.prefetch(uri).then(res => {
          log.debug('prefetched value image', uri, res)
        }).catch(ex => {
          log.error(ex, {
            tags: {
              message: 'error preloading value image'
            }
          })
        })
      }

      map[v.slug] = v
    })

    return map
  } catch (err) {
    return _api.rejectWithValue(err.message || err.msg)
  }
})

const slice = createSlice({
  name: 'values',
  initialState,
  reducers: {
    clearValues: (state) => {
      state.map = {}
      state.status = 'idle'
      state.error = ''
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchValues.pending, (state) => {
        state.status = 'loading'
        state.error = ''
      })
      .addCase(fetchValues.fulfilled, (state, action) => {
        state.map = action.payload
        state.status = 'success'
      })
      .addCase(fetchValues.rejected, (state, action) => {
        state.status = 'error'
        state.error = action.payload || 'Failed to fetch values'
      })
  }
})

export const { clearValues } = slice.actions
export default slice.reducer
